import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="ad-breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-slate-500">
        <li>
          <Link to="/" className="flex items-center gap-1 hover:text-[color:var(--brand-blue)] transition-colors">
            <Home className="w-3.5 h-3.5" /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1">
            <ChevronRight className="w-3.5 h-3.5 text-slate-300" />
            {it.to ? (
              <Link to={it.to} className="hover:text-[color:var(--brand-blue)] transition-colors">
                {it.label}
              </Link>
            ) : (
              <span className="text-slate-700 font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
